module.exports = __webpack_public_path__ + "static/base-7-40421594daa5c3580abc30fb38cae585.jpg";